module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/binding_sample/image07-675606f001a1352438a96b3097d1e75b.png";